import {LocationInfo} from "@/models/location/LocationInfo";

export class LevelInfo{
    id:number = -1;
    name:string = "";
    locations:Array<LocationInfo> = [];
}
